// @ts-nocheck
import React from 'react';
import { Box, Typography, Divider, Chip, Stack } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useAlias } from "./State/AliasContext";

const VistaAlias = () => {
    const { alias } = useAlias();

    return (
        <Box mt={2}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h5" color="primary">
                    {alias.nombre}
                </Typography>
                <Chip label={alias.area?.nombre ?? "Sin área"} color="primary" />
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {alias.mail}
            </Typography>

            <Divider sx={{ my: 3 }}>
                <Typography variant="caption" color="text.secondary">Información</Typography>
            </Divider>

            <Stack spacing={1.5}>
                <Box>
                    <Typography variant="caption" color="text.secondary">Descripción</Typography>
                    <Typography variant="body1">{alias.descripcion}</Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography variant="caption" color="text.secondary">Visibilidad libreta</Typography>
                    <Chip
                        size="small"
                        icon={alias.visibilidadLibreta ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        label={alias.visibilidadLibreta ? "Visible" : "No visible"}
                        variant="outlined"
                    />
                </Box>
            </Stack>

            {alias.destinatarios?.length > 0 && (
                <>
                    <Divider sx={{ my: 3 }}>
                        <Typography variant="caption" color="text.secondary">Destinatarios</Typography>
                    </Divider>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {alias.destinatarios.map((dest, i) => (
                            <Chip key={i} label={dest} variant="outlined" size="small" />
                        ))}
                    </Box>
                </>
            )}
        </Box>
    );
};

export default VistaAlias;
